import React, { Dispatch, SetStateAction } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputEdit, InputMui } from '../../../../../../components';

type ConfigurationInputProps = {
  name: string;
  label: string;
  placeholder: string;
  edited?: boolean;
  disabled?: boolean;
  setDisabled?: Dispatch<SetStateAction<boolean>>;
  inputType?: string;
  step?: number;
  errorMessage?: string;
  min?: number;
  max?: number;
};

const ConfigurationInput: React.FC<ConfigurationInputProps> = ({
  name,
  label,
  placeholder,
  inputType,
  max,
  min,
  edited,
  disabled,
  errorMessage,
  setDisabled,
  step,
}) => {
  const { t } = useTranslation('common');
  const { control, setValue } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: {
          value: true,
          message: t('isRequired'),
        },
        ...(min && max
          ? {
              validate: {
                minThan: (value: string) => parseFloat(value) >= min || t('errors.minNumber', { min }),
                maxThan: (value: string) => parseFloat(value) <= max || t('errors.maxNumber', { max }),
              },
            }
          : {}),
      }}
      render={({ field, fieldState: { error } }) =>
        !edited ? (
          <InputMui
            value={field.value}
            type={inputType}
            onChange={(e) => {
              if (inputType === 'number') setValue(name, parseFloat(e.target.value));
              else field.onChange(e);
            }}
            label={label}
            placeholder={placeholder}
            {...(step ? { step } : {})}
            {...(errorMessage ? { errorMessage } : {})}
          />
        ) : (
          <InputEdit
            value={field.value}
            onChange={(e) => {
              if (inputType === 'number') setValue(name, parseFloat(e.target.value));
              else field.onChange(e);
            }}
            type={inputType}
            label={label}
            disabled={disabled}
            setDisabled={setDisabled}
            step={step}
            {...(error ? { errorMessage: error.message } : {})}
            {...(errorMessage ? { errorMessage } : {})}
          />
        )
      }
    />
  );
};

export default ConfigurationInput;
